<template>
  <div class="data-table">
    <div class="table-container">
      <table class="table" aria-label="Sector stocks">
        <thead>
          <tr class="header-row">
            <th class="header-cell" role="columnheader" scope="col">Sectores</th>
            <th class="header-cell header-cell--sortable header-cell--numeric" role="columnheader" scope="col">
              <div class="header-cell-wrapper" @click="_orderSectorTable('m1')">
                <div class="header-cell-label">Un més</div>
                <div class="sort-indicator" :class="{'active': sort.column === 'm1'}">
                  <span class="material-icons">{{ getSortIcon('m1') }}</span>
                </div>
              </div>
            </th>
            <th class="header-cell header-cell--sortable header-cell--numeric" role="columnheader" scope="col">
              <div class="header-cell-wrapper" @click="_orderSectorTable('m3')">
                <div class="header-cell-label">3 Meses</div>
                <div class="sort-indicator" :class="{'active': sort.column === 'm3'}">
                  <span class="material-icons">{{ getSortIcon('m3') }}</span>
                </div>
              </div>
            </th>
            <th class="header-cell header-cell--sortable header-cell--numeric" role="columnheader" scope="col">
              <div class="header-cell-wrapper" @click="_orderSectorTable('y1')">
                <div class="header-cell-label">1 Año</div>
                <div class="sort-indicator" :class="{'active': sort.column === 'y1'}">
                  <span class="material-icons">{{ getSortIcon('y1') }}</span>
                </div>
              </div>
            </th>
            <th class="header-cell header-cell--numeric" role="columnheader" scope="col">Valores eurekers</th>
            <th class="header-cell" role="columnheader" scope="col">Graficador</th>
          </tr>
        </thead>
        <tbody class="table-content">
          <tr class="table-row" v-for="(sector, index) in _orderTableSector" :key="index">
            <td class="table-cell sector-name">
              <p><strong>{{ sector.displayName }}</strong></p>
              <span>{{ Object.keys(sector.sub_sector).length }} Industrias</span>
            </td>
            <td class="table-cell table-cell--numeric" :class="getValueClass(sector.m1)">{{ formatPercentage(sector.m1) }}</td>
            <td class="table-cell table-cell--numeric" :class="getValueClass(sector.m3)">{{ formatPercentage(sector.m3) }}</td>
            <td class="table-cell table-cell--numeric" :class="getValueClass(sector.y1)">{{ formatPercentage(sector.y1) }}</td>
            <td class="table-cell table-cell--numeric">
              <div v-if="!eurekers_values_ready" class="skeleton skeleton-pill"></div>
              <span v-else-if="eurekers_values && eurekers_values[sector.originalName]">{{eurekers_values[sector.originalName]}}</span>
              <span v-else class="no-value">0</span>
            </td>
            <td class="table-cell options">
              <button class="action-button" @click.prevent="_userPermissionShowStockchart(sector.originalName)" aria-label="Show chart">
                <span class="material-icons">show_chart</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



<script>
import _ from 'lodash';

export default {
  name: 'TableSector',
  props: {
    sectors_table_data: Array,
    eurekers_values: Object,
    eurekers_values_ready: Boolean,
  },
  data: () => ({
    sort: {
      column: 'y1',
      order: 'asc'
    }
  }),
  computed: {
    _orderTableSector() {
      return _.orderBy(this.sectors_table_data, this.sort.column, this.sort.order);
    }
  },
  mounted() {

  },
  methods: {
    _userPermissionShowStockchart(sectorOriginalName) {
      this.$router.push('/app/graficador-dinamico/sector/' + sectorOriginalName);
    },
    _orderSectorTable: function(value) {
      if (this.sort.column === value) {
        this.sort.order = this.sort.order === 'asc' ? 'desc' : 'asc';
      } else {
        this.sort.column = value;
        this.sort.order = 'asc';
      }
    },
    getSortIcon(column) {
      if (this.sort.column !== column) return 'unfold_more';
      return this.sort.order === 'asc' ? 'expand_less' : 'expand_more';
    },
    getValueClass(value) {
      const numValue = parseInt(value);
      if (numValue > 0) return 'value-high';
      if (numValue < 0) return 'value-low';
      return 'value-neutral';
    },
    formatPercentage(value) {
      if (!value && value !== 0) return '0%';
      
      const stringValue = String(value).trim();
      // If the value already has a percentage symbol, just format it
      if (stringValue.includes('%')) {
        const numValue = parseFloat(stringValue.replace('%', ''));
        return isNaN(numValue) ? '0%' : Math.round(numValue) + '%';
      }
      
      // All values are already percentages, just round them
      const numValue = parseFloat(stringValue);
      if (isNaN(numValue)) return '0%';
      
      return Math.round(numValue) + '%';
    }
  },
}
</script>



<style lang="scss" scoped>
  .data-table {
    width: 100%;
    border-radius: 8px;
    background-color: var(--color-surface);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-bottom: 32px;
    overflow: hidden;
    border: 1px solid var(--color-outline);
    transition: all 0.2s ease;
  }

  .table-container {
    width: 100%;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--color-muted) var(--color-surface);
    
    &::-webkit-scrollbar {
      height: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: var(--color-surface);
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background-color: var(--color-muted);
      border-radius: 3px;
      border: 1px solid var(--color-surface);
    }
  }

  .table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    white-space: nowrap;
    font-size: 13px;
    table-layout: fixed;
  }

  .header-row {
    height: 44px;
    background-color: var(--color-background);
    border-bottom: 1px solid var(--color-outline);
  }

  .header-cell {
    color: var(--color-text-secondary);
    font-weight: 600;
    text-align: center;
    text-transform: uppercase;
    padding: 0 12px;
    height: 44px;
    letter-spacing: 0.3px;
    font-size: 11px;
    transition: background-color 0.2s ease;
    vertical-align: middle;
    
    &:nth-child(1) { /* Sectores */
      width: 35%;
      text-align: center;
    }
    
    &:nth-child(2), /* Un més */
    &:nth-child(3), /* 3 Meses */
    &:nth-child(4) { /* 1 Año */
      width: 15%;
    }
    
    &:nth-child(5) { /* Valores eurekers */
      width: 15%;
    }
    
    &:nth-child(6) { /* Gráfico */
      width: 10%;
      text-align: center;
    }

    &--numeric {
      text-align: center;
    }

    &--sortable {
      cursor: pointer;
      
      &:hover {
        background-color: var(--color-active-surface);
      }
    }
  }

  .header-cell-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .sort-indicator {
    display: flex;
    align-items: center;
    opacity: 0.6;
    margin-left: 4px;
    
    &.active {
      opacity: 1;
      color: var(--color-highlight);
    }
    
    .material-icons {
      font-size: 14px;
    }
  }

  .header-cell-label {
    flex-grow: 0;
  }

  .table-row {
    height: 40px;
    border-bottom: 1px solid var(--color-outline);
    transition: background-color 0.2s ease;
    
    &:nth-child(even) {
      background-color: rgba(0, 0, 0, 0.02);
    }
    
    &:last-child {
      border-bottom: none;
    }
    
    &:hover {
      background-color: var(--color-active-surface);
    }
  }

  .table-cell {
    padding: 6px 12px;
    height: 40px;
    text-align: center;
    color: var(--color-text-primary);
    font-size: 13px;
    vertical-align: middle;
    
    &:nth-child(1) { /* Sectores */
      text-align: center;
      white-space: normal;
      word-break: break-word;
    }

    &--numeric {
      text-align: center;
      font-variant-numeric: tabular-nums;
      font-weight: 500;
    }
  }

  .sector-name {
    text-align: center;
    
    strong {
      color: var(--color-text-primary);
      font-weight: 600;
    }
    
    p {
      margin: 0 0 1px 0;
    }
    
    span {
      font-size: 11px;
      color: var(--color-text-secondary);
      opacity: 0.8;
    }
  }

  .options {
    text-align: center;
  }

  .no-value {
    color: var(--color-text-secondary);
    opacity: 0.6;
    font-style: italic;
  }

  .action-button {
    background: transparent;
    border: none;
    border-radius: 4px;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--color-text-secondary);
    transition: all 0.2s ease;
    margin: 0 auto;
    
    &:hover {
      background-color: var(--color-active-surface);
      color: var(--color-highlight);
    }
    
    &:active {
      transform: scale(0.95);
    }
    
    .material-icons {
      font-size: 16px;
    }
  }
  
  .value-high, .value-low {
    color: var(--color-text-primary);
    font-weight: 600;
    position: relative;
    padding-left: 14px;
    
    &::before {
      content: "";
      position: absolute;
      left: 33%;
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 2px;
    }
  }
  
  .value-high::before {
    background-color: var(--color-success);
  }
  
  .value-low::before {
    background-color: var(--color-error);
  }
  
  .value-neutral {
    color: var(--color-text-primary);
    font-weight: 600;
    position: relative;
    padding-left: 14px;
    
    &::before {
      content: "";
      position: absolute;
      left: 33%;
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 2px;
      background-color: var(--color-warning, #ffc107);
    }
  }
  
  .value-medium {
    color: var(--color-warning);
    font-weight: 600;
  }
  
  .value-red, .value-orange, .value-yellow, .value-green, .value-blue {
    display: none;
  }

  /* Skeleton loader for valores eurekers */
  .skeleton {
    display: inline-block;
    width: 40px;
    height: 14px;
    border-radius: 999px;
    background: linear-gradient(90deg, rgba(0,0,0,0.06), rgba(0,0,0,0.12), rgba(0,0,0,0.06));
    background-size: 200% 100%;
    animation: shimmer 1.2s ease-in-out infinite;
    margin: 0 auto;
  }

  .skeleton-pill {
    width: 48px;
    height: 16px;
  }

  @keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
</style>
